<template>
  <RouterView />
</template>

<script>
export default {
  name: 'App',
  components: {}
}
</script>

<style>
* {
  box-sizing: border-box;
}

:root {
  --primary-color: #67229A;
  --secondary-color: #8445b5;
  --text-color: #1d1d1f;
  --background-color: #ffffff;
  --hover-bg: #F2EDFC;
  --light-gray: #f5f5f5;
  --border-color: #e0e0e0;
  --hover-color: #552083;
  --light-purple: rgba(103, 34, 154, 0.05);
  --transition-time: 550ms;
  --slide-time: 7000ms;
  --collapse-time: 300ms;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Montserrat', sans-serif;
  background-color: var(--background-color);
  color: var(--text-color);
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@keyframes bounceIn {
  0% {
    opacity: 0;
    transform: translateX(20px) scale(0.8);
  }
  60% {
    opacity: 1;
    transform: translateX(-5px) scale(1.1);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-100%);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-6px);
  }
  60% {
    transform: translateY(-3px);
  }
}

@keyframes fadeUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cta-container {
  opacity: 0;
  transform: translateY(20px);
  animation: fadeInUp 0.8s ease-out forwards 0.6s;
  display: flex;
  gap: 15px;
  padding-bottom: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-cta {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 18px 30px;
  background-color: var(--primary-color);
  color: white;
  text-decoration: none;
  border-radius: 50px;
  font-weight: 500;
  transition: all 0.3s ease;
  text-align: center;
  min-height: 44px;
  font-size: 18px;
  min-width: 0;
}

.btn-cta:hover {
  background-color: var(--secondary-color);
  transform: scale(1.05);
}

.btn-cta-secondary {
  background-color: transparent;
  box-shadow: inset 0 0 0 2px var(--primary-color);
  color: var(--primary-color);
}

.btn-cta-secondary:hover {
  background-color: rgba(106, 46, 160, 0.1);
  color: var(--primary-color);
  transform: scale(1.05);
}

.cta-button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 12px 24px;
    background-color: var(--primary-color);
    color: white;
    text-decoration: none;
    border-radius: 50px;
    font-weight: 500;
    transition: all 0.3s ease;
    text-align: center;
    min-height: 26px;
    font-size: 16px;
}

.cta-button:hover {
    background-color: var(--secondary-color);
    transform: scale(1.05);
}

.cta-button.secondary {
    background-color: transparent;
    box-shadow: inset 0 0 0 2px var(--primary-color);
    color: var(--primary-color);
}

.cta-button.secondary:hover {
    background-color: rgba(106, 46, 160, 0.1);
    color: var(--primary-color);
    transform: scale(1.05);
}


@media (max-width: 768px) {
  .cta-container {
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding-bottom: 44px;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    margin: 0;
  }

  .btn-cta {
    width: 100%;
    max-width: none;
    padding: 14px 28px;
    font-size: 18px;
    font-weight: 500;
    min-height: 48px;
  }

  .btn-cta-secondary {
    width: 100%;
    max-width: none;
    padding: 14px 28px;
    font-size: 18px;
    font-weight: 500;
    min-height: 48px;
  }
}

/* Definicja animacji obrotu */
@keyframes spinAround {
  from { transform: rotate(0deg); }
  to { transform: rotate(359deg); }
}

.button.is-loading {
  color: transparent !important; /* Ukrywamy tekst przycisku */
  pointer-events: none;          /* Blokujemy kliknięcia w trakcie ładowania */
  position: relative;
}

.button.is-loading::after {
  content: "";
  display: block;
  position: absolute;
  
  /* Wygląd kółka */
  width: 16px;
  height: 16px;
  border: 2px solid #dbdbdb;
  border-radius: 290486px;
  border-right-color: transparent;
  border-top-color: transparent;
  
  /* Pozycjonowanie na środku */
  left: calc(50% - (16px / 2));
  top: calc(50% - (16px / 2));
  
  /* Uruchomienie animacji */
  animation: spinAround 500ms infinite linear;
}

</style>